__turbopack_context__.v({
  "className": "MHLVpq_className",
  "variable": "MHLVpq_variable",
});
